// extracted by css-extract-rspack-plugin
export default {"list":"list--EqwooH26XmgfYnFr","listItem":"list-item--aaDW6XZTg58hInnW"};